import { render } from "./ManageSFTypesModal.vue?vue&type=template&id=1a21f5bb"
import script from "./ManageSFTypesModal.vue?vue&type=script&lang=js"
export * from "./ManageSFTypesModal.vue?vue&type=script&lang=js"

import "./ManageSFTypesModal.vue?vue&type=style&index=0&id=1a21f5bb&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__